import { render, staticRenderFns } from "./CreateEmployeeAllowance.vue?vue&type=template&id=2856a5fd"
import script from "./CreateEmployeeAllowance.vue?vue&type=script&lang=js"
export * from "./CreateEmployeeAllowance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports